"use strict";

const GridRowRenderer = require('../GridRowRenderer');
class LockedGridRowRenderer extends GridRowRenderer{
    constructor(model) {
        super(model);

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _createRootElement() {
        return document.createElement("locked-grid-row");
    }

    _registerListeners() {
       return super._registerListeners();
    }

    _unregisterListeners() {
        return super._unregisterListeners();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return super.render();
    }

    shutdown() {
        return super.shutdown();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/


    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _getColumns() {
        return this._model.getLockedColumns();
    }

    /**
     * Rebuild the row with the new column order
     * @param lockedColumns {Array} - Array of Strings (column ids) representing the order of the locked columns
     * @private
     */
    _setLockedColumns(lockedColumns) {
        return super._setLockedColumns(lockedColumns);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = LockedGridRowRenderer;
